module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "بعد-ساعات-قليلة"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد ساعاتٍ قليلة")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("داهمَت قوات الأمن مقرّاتهم وأماكن تجمّعاتهم ولاحقتهم في الشّوارع، لكنَّهم نجحُوا في تخليص أنفسهم بصعوبةٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("\"صمتًا\" همسَ حازم ملفِتًا انتباه رفاقه إليه ثمَّ قال: اسمعُوا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نهضَ من مكانه بهدوءٍ وأخذ السِّراج ومشى في المَمرّ المؤدّي إلى الباب بهدوءٍ، لم يُفسد حالة السّكون في البيت سوى الصّوتِ الَّذي يُصدِره خشبُ الأرضيَّة القديم، تَبِعه رشيد بهدوءٍ، وأمسك بيده قبل أن يفتح الباب، وقال:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- دعني أتأكّد أوّلًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَزِمَ حازم مكانَه وبيده السِّراج، في حين اتّجه رشيدٌ نحو النّافذة المُطِلّة على الشّارع وبيده مسدّس، وقف مُسنِدًا كتفه الأيمن على الجدار وفتح السّتارة بحذَرٍ وأخذ ينظر إلى الجهة الخارجيَّة من الباب، ثمَّ أعطى إشارةً لحازم ليفتَح الباب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فتح حازم الباب: عليّ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان الحزن واضحًا على وجه عليّ. وسارعَ رشيدٌ لسؤالهِ:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كيفَ حالُه؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ عليّ: فقدَ الكثير من الدّم ولم نستطع إنقاذه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- عرفتُ أنَّه لن ينجو.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا وقتَ لدينا، يجب أن نختبئ؛ إنَّهم يبحثون عنّا في كلِّ مكان.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لكن هذا آمَنُ مكانٍ لدينا يا عليّ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لم يَعدْ كذلك، سمعتُ بأنَّهم فتَّشوا أماكنَ أكثر سِرّية، إنَّهم يعرفون جيّدًا أين يبحثون.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لِيسأله نصرت: أين تريدنا أن نذهب؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ كاظمُ: مكتبة العمّ ناجي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظلّ عِزّت ساكتًا طوال الوقت ثمَّ انفجر قائلًا:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أرأيتم إلى أين أوصَلَنا صديقك يا عليّ بأفكاره وشهيَّته المفتوحة للعُنف؟ قلت لكم: لا داعي لرَفْع السّلاح، لم تسمَعوا كلامي؛ وهذه هي النّتيجة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمسك رشيد بيد عِزّت وقال بهدوءٍ:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يكفي، ليس الوقت ولا المكان مناسبَين لمناقشة هذا الأمر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فردَّ عزّت غاضبًا: متى إذًا؟! هل ننتظرُ إلى أن يأتينا الدَّور؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قال عليّ مُقاطِعًا الحوار الَّذي بين رشيد وعزّت:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يكفي، ما مُشكلتك مع الرَّجل يا عِزّت؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- بعد كلِّ هذا تسأل ما مشكلتي يا عليّ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يتدّخلُ حازمُ بقولِهِ: لقد خرجنا في هذا الطّريق جميعًا، وجَمَعَنا هدفٌ واحدٌ، فلماذا نختلف على الطّريقة ما دام الهدفُ واحدًا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّ عِزّت: لأنَّه لم يكن من أهدافنا رفعُ السّلاح على رجال الأمن يا حازم، لكن منذُ أن دخل بيننا أصبحَ العنفُ خيارَنا للردّ على الأمن وعلى كلِّ من لا يتَّفق معنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4788824c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch010.vue
// module id = 87
// module chunks = 0